<template>
  <div class="student-record-detail-topBar">
    <div class="btn-list">
      <el-button @click="$router.back()" size="small">返回</el-button>
      <!-- <el-date-picker v-show="tabSelectName !== 'fourth'" class="select" v-model="dateVal" type="date"
        placeholder="选择日期">
      </el-date-picker> -->
      <div style="display: flex; align-items: center;" v-show="tabSelectName !== 'fourth'">
        <el-radio-group style="margin-left: 20px;" v-model="pickerType" size="small"
          v-show="tabSelectName !== 'fifth' && tabSelectName !== 'sixth' && tabSelectName !== 'second'">
          <el-radio-button label="month">选择月份</el-radio-button>
          <el-radio-button label="date">选择日期</el-radio-button>
        </el-radio-group>

        <!-- 使用 v-show 来控制显示状态 -->
        <el-date-picker class="select"
          v-show="pickerType === 'month' && tabSelectName !== 'fifth' && tabSelectName !== 'second' && tabSelectName !== 'sixth'" ref="monthPicker"
          v-model="monthVal" type="month" value-format="yyyy-MM" placeholder="选择月份" @change="monthChange">
        </el-date-picker>

        <el-date-picker class="select"
          v-show="pickerType === 'date' && tabSelectName !== 'fifth' && tabSelectName !== 'second' && tabSelectName !== 'sixth'" ref="datePicker"
          v-model="dateVal" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" @change="dateChange">
        </el-date-picker>

        <!-- <el-date-picker class="select" v-model="schoolYearVal" type="year" value-format="yyyy" placeholder="学年">
        </el-date-picker> -->
        <year-range-picker class="select" style="width: 280px;" v-model="schoolYearVal" />
        <el-select class="select" v-model="semesterVal" placeholder="学期" clearable>
          <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
            :value="item.dictValue">
          </el-option>
        </el-select>

        <el-button type="primary" style="margin-left: 20px;" size="small" @click="search">搜索</el-button>
      </div>
    </div>
    <div
      v-show="tabSelectName !== 'third' && tabSelectName !== 'fourth' && tabSelectName !== 'fifth' && tabSelectName !== 'sixth'">
      <el-button type="success" size="small" @click="addRecord" v-hasPermi="'sc:studentrecord:add'">新增</el-button>
    </div>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";
export default {
  props: ['tabSelectName', 'semesterOptions', 'searchData'],
  components: { search },
  data() {
    return {
      dateVal: '',
      monthVal: '',
      pickerType: 'month',
      schoolYearVal: "",
      semesterVal: "",
    };
  },
  watch: {
    pickerType(newValue, oldValue) {
      this.handleRadioChange();
    }
  },
  methods: {
    // 监听 radio 按钮改变事件，关闭之前打开的选择器
    handleRadioChange() {
      this.$nextTick(() => {
        if (this.$refs.monthPicker) this.$refs.monthPicker.blur();
        if (this.$refs.datePicker) this.$refs.datePicker.blur();
      });
    },
    // 新增记录
    addRecord() {
      this.$emit('addRecord');
    },
    monthChange(e) {
      // console.log(e);
      // this.$emit('interviewTimeSearch', e);
    },
    dateChange(e) {
      // console.log(e);
      // this.$emit('interviewTimeSearch', e);
    },
    search() {
      if (this.tabSelectName == 'fifth' || this.tabSelectName == 'sixth') {
        if (this.schoolYearVal == '' || this.semesterVal == '') return this.$message.warning('请选择学年或学期');
      };
      this.$emit('search', {
        interviewTime: this.pickerType == 'month' ? this.monthVal : this.dateVal,
        schoolYear: this.schoolYearVal,
        semester: this.semesterVal,
      });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "./studentRecordDetailTopBar.scss";
</style>